type UpdatePermissionsFunction = (
  entity: string,
  permissions: string[]
) => void;

const shouldUpdatePermissions = (pendingPermissions: string[]): boolean =>
  !!pendingPermissions.length;

export const handlePermissionsSave = (
  pendingPermissions: string[],
  permissionItems: string[],
  entity: string,
  updatePermissions: UpdatePermissionsFunction
): void => {
  if (shouldUpdatePermissions(pendingPermissions)) {
    updatePermissions(entity, permissionItems);
  }
};
